import { render, staticRenderFns } from "./ViewEditProfile.vue?vue&type=template&id=73a0664a&"
import script from "./ViewEditProfile.vue?vue&type=script&lang=js&"
export * from "./ViewEditProfile.vue?vue&type=script&lang=js&"
import style0 from "./ViewEditProfile.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports